import i18n from '../i18n';

export interface IDialogType {
   id: string;
   dialogName: string;
   menuName?: string;
}

const buildType = (id: string, dialogName: string, menuName?: string): IDialogType => ({
   id,
   dialogName,
   menuName,
});

export const DialogTypes = {
   AuthenticatorSetupDialog: buildType(
      'totp_setup',
      i18n.t('Add Authenticator App'),
      i18n.t('Add Authenticator App...')
   ),
   AuthenticatorVerifyDialog: buildType(
      'totp_verify',
      i18n.t('Verify Authentication Code'),
      i18n.t('Verify Authentication Code...')
   ),
   AdminRolesDialog: buildType('admin_roles', i18n.t('Admin Roles'), i18n.t('Admin Roles...')),
   SystemStatusDialog: buildType(
      'system_status',
      i18n.t('Diplomat Status'),
      i18n.t('Diplomat Status...')
   ),
   CreateOpenPGPKeyPair: buildType(
      'create_openpgp_key_pair',
      i18n.t('Create OpenPGP Key Pair'),
      i18n.t('Create Key Pair...')
   ),
   OpenPGPSubKeyCreation: buildType('open_pgp_subkey_creation', i18n.t('Key Creation')),
   ImportOpenPGPKeysDialog: buildType(
      'import_openpgp_keys',
      i18n.t('Import OpenPGP Key Pairs'),
      i18n.t('Import Key Pairs...')
   ),
   AddOpenPGPSubkeys: buildType(
      'add_open_openpgp_subkeys',
      i18n.t('Create OpenPGP Subkeys'),
      i18n.t('Add Subkeys')
   ),
   ReplaceKey: buildType('replace_key', i18n.t('Replace Key'), i18n.t('Replace Key...')),
   DeletePGPKeyDialog: buildType('delete_pgp_key', i18n.t('Delete PGP Key'), i18n.t('Delete')),
   RecoverOpenPgpPublicKeysDialog: buildType(
      'recover_openpgp_public_keys',
      i18n.t('Recover OpenPGP Keys'),
      i18n.t('Recover...')
   ),
   RecoverOpenPgpKeyPairsDialog: buildType(
      'recover_openpgp_key_pairs',
      i18n.t('Recover OpenPGP Keys'),
      i18n.t('Recover...')
   ),
   CreateSSHKeyPair: buildType(
      'ssh_key_pair',
      i18n.t('Create SSH Key Pair'),
      i18n.t('Create Key Pair...')
   ),
   DeleteSSHKeyPairDialog: buildType(
      'delete_ssh_key_pair',
      i18n.t('Delete SSH Client Key Pair'),
      i18n.t('Delete')
   ),
   RecoverSSHPublicKeysDialog: buildType(
      'recover_ssh_public_keys',
      i18n.t('Recover SSH Client Keys'),
      i18n.t('Recover...')
   ),
   RecoverSSHKeyPairsDialog: buildType(
      'recover_ssh_key_pairs',
      i18n.t('Recover SSH Client Keys'),
      i18n.t('Recover...')
   ),
   ImportSSHKeyPair: buildType(
      'import_ssh_key_pair',
      i18n.t('Import SSH Client Key'),
      i18n.t('Import Key Pair...')
   ),
   ImportSSHPublic: buildType(
      'import_ssh_public',
      i18n.t('Import SSH Public Key'),
      i18n.t('Import Public Key...')
   ),
   SearchSSHClientKeysDialog: buildType(
      'search_ssh_client_keys',
      i18n.t('SSH Client Key Search/Move'),
      i18n.t('Search/Move...')
   ),
   SearchSSHPublicKeysDialog: buildType(
      'search_ssh_public_keys',
      i18n.t('SSH Public Key Search/Move'),
      i18n.t('Search/Move...')
   ),
   ImportSSLServerCertificate: buildType(
      'ssl_server_cert',
      i18n.t('Import Server SSL Certificate'),
      i18n.t('Import Server SSL Certificate...')
   ),
   ImportSSLClientCertificate: buildType(
      'ssl_client_cert',
      i18n.t('Import Client SSL Certificate'),
      i18n.t('Import Client SSL Certificate...')
   ),
   DeleteSSLCertificateDialog: buildType(
      'delete_ssl_cert',
      i18n.t('Delete SSL Certificate'),
      i18n.t('Delete')
   ),
   SearchSSLKeysDialog: buildType(
      'search_ssl_keys',
      i18n.t('SSL Certificate Search/Move'),
      i18n.t('Search/Move...')
   ),
   RenameKeyDialog: buildType('rename_key', '', i18n.t('Rename...')),
   MoveKeysDialog: buildType('move_keys', 'Choose Target Folder', i18n.t('Move...')),
   CreateInternalPartner: buildType(
      'create_internal_partner',
      i18n.t('Create New Partner Profile'),
      i18n.t('Create Trusted Partner...')
   ),
   CreateExternalPartner: buildType(
      'create_external_partner',
      i18n.t('Create New Partner Profile'),
      i18n.t('Create Public Partner...')
   ),
   RenamePartnerDialog: buildType('rename_partner', '', i18n.t('Rename...')),
   MovePartnerDialog: buildType('move_partner', 'Choose Target Folder', i18n.t('Move...')),
   DeletePartnerDialog: buildType('delete_partner', 'Delete Partner', i18n.t('Delete')),
   SaveAsPartnerDialog: buildType('saveas_partner', 'Save Partner As', i18n.t('Save As...')),

   SshHostKeysDialog: buildType(
      'ssh_host_keys',
      i18n.t('SSH Host Keys'),
      i18n.t('SSH Host Keys...')
   ),

   FileLicenseDialogBox: buildType('license', i18n.t('Diplomat License'), i18n.t('License...')),
   BackupDialog: buildType('backup', i18n.t('Backup'), i18n.t('Backup...')),

   HelpAboutBox: buildType('about', i18n.t('About Diplomat'), i18n.t('About...')),
   SupportTicket: buildType(
      'support_ticket',
      i18n.t('Generate Support Data ZIP file'),
      i18n.t('Support ticket...')
   ),

   SettingsFTPDialog: buildType('settings-ftp', i18n.t('FTP Settings'), i18n.t('FTP...')),
   SettingsOpenPGPKeys: buildType(
      'openpgp_settings',
      i18n.t('Default OpenPGP Key Settings'),
      i18n.t('OpenPGP Keys...')
   ),
   SettingsJobMonitorDialog: buildType(
      'job_monitor',
      i18n.t('Job Monitor Settings'),
      i18n.t('Job Monitor...')
   ),
   SettingsAuditTrailDialog: buildType(
      'audit_trail',
      i18n.t('Audit Trail Settings'),
      i18n.t('Audit...')
   ),
   SettingsEmailDialog: buildType('email', i18n.t('Email Settings'), i18n.t('Email...')),
   SettingsPagingDialog: buildType(
      'paging',
      i18n.t('Paging Settings'),
      i18n.t('Paging Notification...')
   ),
   SettingsProxiesDialog: buildType('proxies', i18n.t('Proxy Servers'), i18n.t('Proxy Servers...')),
   EditProxy: buildType(
      'edit_proxy',
      i18n.t('Edit Proxy Servers'),
      i18n.t('Edit Proxy Servers...')
   ),
   AddProxy: buildType('add_proxy', i18n.t('Add Proxy Servers'), i18n.t('Add Proxy Servers...')),
   ViewProxy: buildType(
      'view_proxy',
      i18n.t('View Proxy Servers'),
      i18n.t('View Proxy Servers...')
   ),

   JobQueueSettingsDialog: buildType(
      'job_queue',
      i18n.t('Job Queue Settings'),
      i18n.t('Job Queue...')
   ),

   BackupSettingsDialog: buildType(
      'backup_settings',
      i18n.t('Backup Settings'),
      i18n.t('Backup...')
   ),
   Calendars: buildType('calendars', i18n.t('Calendars'), i18n.t('Calendars...')),
   AddCalendar: buildType('add_calendar', i18n.t('Add Calendar'), i18n.t('Add Calendar...')),
   EditCalendar: buildType('edit_calendar', i18n.t('Edit Calendar'), i18n.t('Edit Calendar...')),
   AddHoliday: buildType('add_holiday', i18n.t('Define Holiday'), i18n.t('Add Holiday...')),
   AddUSHoliday: buildType('add_us_holiday', i18n.t('US Holidays'), i18n.t('Add US Holidays...')),
   ViewCalendar: buildType('view_calendar', i18n.t('View Calendar'), i18n.t('View Calendar...')),

   FileManager: buildType('filemanager', i18n.t('File Manager'), i18n.t('File Manager')),
   FileManagerMerge: buildType('filemanager_merge', i18n.t('File Manager'), i18n.t('File Manager')),
   CertDialog: buildType('certdialog', i18n.t('Certificate Dialog'), i18n.t('Certificate Dialog')),
   SFTPFileManager: buildType(
      'sftp_filemanager',
      i18n.t('SFTP File Manager'),
      i18n.t('SFTP File Manager')
   ),

   AuditWarningDialog: buildType(
      'audit_warning',
      i18n.t('Audit Database Update Warning'),
      i18n.t('Audit Warning')
   ),
   AuditSuspensionDialog: buildType(
      'audit_suspension',
      i18n.t('Job Suspension Status'),
      i18n.t('Audit Suspension')
   ),

   ThreatIntelligenceSettings: buildType(
      'threat_intelligence_settings',
      i18n.t('Advanced Threat Intelligence Settings'),
      i18n.t('Threat Intelligence...')
   ),
   IPAccessRules: buildType(
      'ip_access_rules',
      i18n.t('IP Access Rules...'),
      i18n.t('IP Access Rules...')
   ),
   SftpIPAccessRulesDialog: buildType(
      'sftp_ip_access_rules',
      i18n.t('IP Access Rules...'),
      i18n.t('IP Access Rules...')
   ),

   SettingsPrimaryArchive: buildType(
      'archive_settings',
      i18n.t('Primary Archive Settings'),
      i18n.t('Primary Archive...')
   ),
   UserAccountSettingDialog: buildType(
      'account_settings',
      i18n.t('Admin Users Settings'),
      i18n.t('Admin Users...')
   ),
   AddUserAccount: buildType('add_user', i18n.t('Add Admin User'), i18n.t('Add Admin User...')),
   EditUserAccount: buildType('edit_user', i18n.t('Edit Admin User'), i18n.t('Edit Admin User...')),

   AuthPoliciesDialog: buildType(
      'auth_policies',
      i18n.t('Admin Policies'),
      i18n.t('Admin Policies...')
   ),

   SetPassword: buildType('set_pass', i18n.t('Set Password'), i18n.t('Set Password...')),
   ChangePasswordDialog: buildType(
      'change_password',
      i18n.t('Change Password'),
      i18n.t('Change Password')
   ),
   ITSupportEmailSettingsDialog: buildType(
      'it_support_email_settings',
      i18n.t('IT Support Email Notification Settings'),
      i18n.t('IT Support Email Notification...')
   ),
   LogSettingsDialog: buildType('log_settings', i18n.t('Logging Settings'), i18n.t('Logging...')),
   SessionDataDialog: buildType(
      'session_settings',
      i18n.t('Session Management'),
      i18n.t('Session Management...')
   ),
   LDAPSettingsDialog: buildType(
      'ldap_settings',
      i18n.t('LDAP Authentication Configuration'),
      i18n.t('LDAP...')
   ),
   AuditSummaryReportDialog: buildType(
      'audit_summary_report_params',
      i18n.t('Job Report Parameters'),
      i18n.t('Job Summary Report...')
   ),
   AuditReportDialog: buildType(
      'audit_report_params',
      i18n.t('Job Report Parameters'),
      i18n.t('Job Detail Report...')
   ),
   UserActivityReportDialog: buildType(
      'user_activity_report',
      i18n.t('Admin Activity Report Parameters'),
      i18n.t('Admin Activity Report...')
   ),
   SFTPActivityReportDialog: buildType(
      'sftp_activity_report',
      i18n.t('File Transfer Activity Report Parameters'),
      i18n.t('File Transfer Activity Report...')
   ),
   SFTPConnectionsReportDialog: buildType(
      'sftp_connections_report',
      i18n.t('File Transfer Connections Report Parameters'),
      i18n.t('File Transfer Connections Report...')
   ),
   ScheduledReports: buildType(
      'scheduled_reports',
      i18n.t('Scheduled Reports Parameters'),
      i18n.t('Scheduled Reports...')
   ),
   SearchOpenPGPKeysDialog: buildType(
      'search_open_pgp_keys',
      i18n.t('OpenPGP Key Search/Move'),
      i18n.t('Search/Move...')
   ),
   SearchPartnerDialog: buildType(
      'search_partners',
      i18n.t('Partner Search/Move'),
      i18n.t('Search/Move...')
   ),

   CreateInboundTransaction: buildType(
      'create_inbound_transaction',
      i18n.t('Create New Inbound Transaction'),
      i18n.t('Create Inbound Transaction...')
   ),
   CreateOutboundTransaction: buildType(
      'create_outbound_transaction',
      i18n.t('Create New Outbound Transaction'),
      i18n.t('Create Outbound Transaction...')
   ),
   SearchTransactionsDialog: buildType(
      'search_transactions',
      i18n.t('Transaction Search/Move'),
      i18n.t('Search/Move...')
   ),
   SearchSynchronizationDialog: buildType(
      'search_sync',
      i18n.t('Synchronization Search/Move'),
      i18n.t('Search/Move...')
   ),
   SaveTransactionAsDialog: buildType(
      'saveas_transactions',
      i18n.t('Save Transaction As'),
      i18n.t('Save As...')
   ),
   SaveSynchronizationAsDialog: buildType(
      'saveas_synchronization',
      i18n.t('Save Synchronization As'),
      i18n.t('Save As...')
   ),
   RenameTransactionDialog: buildType(
      'rename_transactions',
      i18n.t('Rename transaction'),
      i18n.t('Rename...')
   ),
   DeleteTransactionDialog: buildType(
      'delete_transactions',
      i18n.t('Delete transaction'),
      i18n.t('Delete')
   ),
   DeleteSynchronizationDialog: buildType(
      'delete_sync',
      i18n.t('Delete synchronization'),
      i18n.t('Delete')
   ),
   MoveTransactionDialog: buildType(
      'move_transactions',
      i18n.t('Move transaction'),
      i18n.t('Move')
   ),
   MoveSynchronizationDialog: buildType(
      'move_sync',
      i18n.t('Move Synchronization'),
      i18n.t('Move')
   ),
   RunNowTransactionDialog: buildType(
      'runnow_transactions',
      i18n.t('Run Now Transaction'),
      i18n.t('Run Now...')
   ),
   RunNowTransactionFromTreeDialog: buildType(
      'runnow_transactions_from_tree',
      i18n.t('Run Now Transaction'),
      i18n.t('Run Now...')
   ),

   LogsDialog: buildType('logs', i18n.t('Logs'), i18n.t('Logs...')),
   LogViewerLastStartEndDialog: buildType(
      'view_logs_last',
      i18n.t('View Log'),
      i18n.t('View Log...')
   ),

   FolderAddDialog: buildType(
      'add_folder',
      i18n.t('Create Sub-folder'),
      i18n.t('Add Subfolder...')
   ),
   FolderRenameDialog: buildType('rename_folder', i18n.t('Rename folder'), i18n.t('Rename...')),
   FolderDeleteDialog: buildType('delete_folder', i18n.t('Folder Delete'), i18n.t('Delete')),
   MoveFolderDialog: buildType('move_folder', i18n.t('Choose Target Folder'), i18n.t('Move...')),

   InputDialog: buildType('input', i18n.t('Input'), i18n.t('Input')),
   SelectDialog: buildType('select', i18n.t('Select'), i18n.t('Select')),
   StatusDialog: buildType('status_text', i18n.t('Status'), i18n.t('Status')),
   PendingChangesDialog: buildType(
      'pending_changes',
      i18n.t('Pending changes'),
      i18n.t('Pending changes')
   ),
   TroubleShootingDialog: buildType(
      'troubleshooting',
      i18n.t('Advanced Troubleshooting Warning'),
      i18n.t('Troubleshooting')
   ),

   KeyUsageDialog: buildType('key_usage', i18n.t('Key Usage'), i18n.t('Key Usage...')),

   SFTPServerSettings: buildType(
      'sftp_server_settings',
      i18n.t('File Transfer Server Settings'),
      i18n.t('Settings...')
   ),
   CreateSftpUser: buildType('create_sftp_user', i18n.t('Create User'), i18n.t('Create User...')),
   SearchSftpUserDialog: buildType(
      'search_sftp_user',
      i18n.t('Search User'),
      i18n.t('Search User...')
   ),
   RenameSftpUserDialog: buildType('rename_sftp_user', i18n.t('Rename User'), i18n.t('Rename...')),
   DeleteSftpUserDialog: buildType('delete_sftp_user', i18n.t('Delete User'), i18n.t('Delete')),
   MoveSftpUserDialog: buildType('move_sftp_user', i18n.t('Move User'), i18n.t('Move')),

   CreateSftpGroup: buildType(
      'create_sftp_group',
      i18n.t('Create Group'),
      i18n.t('Create Group...')
   ),
   DeleteSftpGroupDialog: buildType('delete_sftp_group', i18n.t('Delete Group'), i18n.t('Delete')),
   RenameSftpGroupDialog: buildType(
      'rename_sftp_group',
      i18n.t('Rename Group'),
      i18n.t('Rename...')
   ),
   MoveSftpGroupDialog: buildType('move_sftp_group', i18n.t('Move Group'), i18n.t('Move')),

   CreatePhysicalFolderDialog: buildType(
      'create_phys_folder',
      i18n.t('Create Physical Folder'),
      i18n.t('Create Physical Folder...')
   ),
   CreateVirtualFolderDialog: buildType(
      'create_virtual_folder',
      i18n.t('Create Virtual Folder'),
      i18n.t('Create Virtual Folder...')
   ),
   DeleteVFSNode: buildType(
      'delete_vfs_node',
      i18n.t('Delete Filesystem Node'),
      i18n.t('Delete Filesystem Node...')
   ),
   CreateSynchronization: buildType(
      'create_synchronization',
      i18n.t('Create Synchronization'),
      i18n.t('Create Synchronization...')
   ),

   ConfirmationDialog: buildType('confirmation', i18n.t('Confirmation'), i18n.t('Confirmation')),
   VFSPermsWarningDialog: buildType(
      'Warning',
      i18n.t('Permissions warning'),
      i18n.t('Permissions warning')
   ),
   PermissionsDialog: buildType('permissions', i18n.t('Permissions'), i18n.t('Permissions')),
   ConfirmDialog: buildType('confirm', i18n.t('Confirmation'), i18n.t('Confirmation')),
   CancelableConfirmationDialog: buildType(
      'confirm_yes_no_cancel',
      i18n.t('Confirmation'),
      i18n.t('Confirmation')
   ),
   AlertDialog: buildType('alert', i18n.t('alert'), i18n.t('alert')),
   RoiReportDialog: buildType('roi_report', i18n.t('ROI Report'), i18n.t('ROI Report')),
   ConnectionAuditReportDialog: buildType(
      'connection_audit',
      i18n.t('Connection Audit Report'),
      i18n.t('Connection Audit Report...')
   ),
   SettingsSAMLDialog: buildType('sso_ettings', i18n.t('SSO Settings'), i18n.t('SSO Settings')),
};

export const DialogResult = {
   OK: 'OK',
   NO: 'NO',
   CANCEL: 'CANCEL',
   AUDIT_SUSPEND: 'AUDIT_SUSPEND',
   AUDIT_DONT_SUSPEND: 'AUDIT_DONT_SUSPEND',
};
